exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StudentAnswerQuiz{background:#fff;padding:20px}.StudentAnswerQuiz .question-container{max-width:1120px;width:1120px;margin:0}.StudentAnswerQuiz .question-container h3{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/StudentAnswerQuiz/style.scss
// module id = 5031
// module chunks = 0